module.exports = __webpack_public_path__ + "static/media/Oaktree---school-professional---hero.d6bfc2a1.svg";